import Vue from 'vue'
import Icon from 'vue-awesome'
import { addComponent } from '~/utils/helper'

Vue.use(addComponent(Icon))


// WEBPACK FOOTER //
// ./plugins/VueAwesome.js